<template>
  <div>
    <Consulta
        ref="filtroConsulta"
        titulo="Historico de Nome Social"
        :consulta-callback="consulta"
        :parametros="paramsFiltro"
        :colunas="headers"
        :ordenacao-colunas="sortBy"

    >
      <template v-slot:areaParametros>
        <v-row dense>
          <v-col cols="6">
            <v-text-field
                v-model="paramsFiltro.nome"
                dense
                label="Nome"
                name="nomeInscricao"
                outlined
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field
                v-model="paramsFiltro.cpf"
                v-mask="'###########'"
                :counter="11"
                dense
                label="CPF"
                maxlength="11"
                name="cpfInscricao"
                outlined
            ></v-text-field>
          </v-col>
        </v-row>
      </template>
      <template v-slot:item.aprovado="{ item }">
        {{ item.aprovado === true ? 'Sim' : item.aprovado === false ? 'Não' : '-' }}
      </template>
      <template v-slot:item.data="{ item }">
        {{ formatarData(item.data) }}
        </template>
      <template v-slot:item.status="{ item }">
        <v-select
            v-model="item.avaliacao"
            :items="[
                  { text: 'Sim', value: true },
                  { text: 'Não', value: false }
                ]"
            :rules="[campoObrigatorioRule]"
            dense
            label="avaliacao *"
            outlined
        ></v-select>
      </template>
      <template v-slot:item.avaliacao="{ item }">
        <v-btn outlined v-model="item.avaliacao" @click="atualizaAvaliacao(item)">

          <div>
            <v-icon>mdi mdi-arrow-left-bottom </v-icon>
          </div>
        </v-btn>

      </template>
    </Consulta>
  </div>
</template>

<script>


import Consulta from "@/components/pages/admin/consultas/Consulta.vue";

import historicoNomeSocialService from "@/services/historicoNomeSocial.service";
import {mapActions} from "vuex";


export default {
  name: "HistoricoNomeSocial",
  components: {Consulta},
  data() {
    return {
      consulta: historicoNomeSocialService.recuperarFiltro,
      headers: [
        {text: "Nome", value: "nome"},
        {text: "CPF", value: "cpf"},
        {text: "Nome Social", value: "nomeSocial"},
        {text: "Aprovado", value: "aprovado"},
        {text: "Data", value: "data"},
        {text:"CPFResponsavel", value:"cpfResponsavel"},
        {
          text: "Desfazer",
          value: "avaliacao",
          align: "center"
        }
      ],
      sortBy: ["nome"],
      paramsFiltro: {},
      situacoes: [
        {value: true, text: 'Aprovado'},
        {value: false, text: 'Reprovado'}
      ]

    }
  },

  async mounted() {
    this.$refs.filtroConsulta.mostrarResultado = true;

    await this.$refs.filtroConsulta.consultar();

  },
  methods: {
    ...mapActions("avisos", ["exibirAviso"]),

    formatarData(data) {
      if (!data) return '-'
      const d = new Date(data)
      return d.toLocaleDateString('pt-BR')
    },

    async atualizaAvaliacao(item) {
      await historicoNomeSocialService
          .atualizaAvaliacao(item)
          .then(() => {
            this.$refs.filtroConsulta.getDataFromApi();
            this.exibirAviso({
              mensagem: item.avaliacao ? "Pedido mandado para a Reavaliação com sucesso" : "!",
              tipo: "success"
            });
          })
          .catch(error => {
            let mensagem;
            if (error.response && error.response.status === 404) {
              mensagem = "Usuário não encontrado";
            } else {
              mensagem = "Não foi possivel mandar para Reavaliação.";
            }
            this.exibirAviso({
              mensagem: mensagem,
              tipo: "error"
            });
          });
    }
  }

};

</script>

